import React from 'react';
import { deleteDiscountConfig } from 'apis/adminServices/adminDiscountService';
import { useGlobalLoader } from 'contexts/GlobalLoaderContext';
import { useToastStore } from 'store/toastStore';

interface ConfirmDeleteModalProps {
  tierId: number;
  onClose: () => void;
  onDeleteSuccess: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  tierId,
  onClose,
  onDeleteSuccess
}) => {
  const { showLoader, hideLoader } = useGlobalLoader();
  const { showToast } = useToastStore();

  const handleDelete = async () => {
    showLoader();
    try {
      await deleteDiscountConfig(tierId);
      showToast('Discount deleted successfully', 'success');
      onDeleteSuccess();
    } catch (error) {
      console.error('Error deleting discount:', error);
      showToast('Failed to delete discount', 'error');
    } finally {
      hideLoader();
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl relative">
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="2" 
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h3 className="text-lg font-semibold mb-4">Confirm Deletion</h3>
        <p className="mb-6">
          Are you sure you want to delete this configuration?
        </p>
        <div className="flex justify-end gap-4">
          <button
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
            onClick={onClose}
          >
            No
          </button>
          <button
            className="px-4 py-2 bg-[#FFD700] text-white hover:bg-[#E6C200] rounded-md focus:outline-none focus:ring-2 focus:ring-[#F5C400]"
            onClick={handleDelete}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;